import LoginForm from './login-form';
import ChangePasswordForm from './change-password-form';
import ClientRegisterForm from './client-register-form';
import ForgotPasswordForm from './forgot-password-form';
import ImportsForm from './imports-form';
import HolderForm from './holder-form';
import NotificationForm from './notification-form';
import OperatorForm from './operator-form';
import ResetPasswordForm from './reset-password-form';
import SiteForm from './site-form';
import SingleReaderForm from './single-reader-form';
import AgentForm from './agent-form';
import ZoneForm from './zone-form';
import ReaderForm from './reader-form';
import AntennaForm from './antenna-form';
import CameraForm from './camera-form';
import ProfileForm from './profile-form';
import DetectablesForm from './detectables-form';
import ClientConfigForm from './client-config-form';

import LinkedNavigationMenu from './linked-top-navigation';
import LinkedSideNavigation from './linked-side-navigation';
import NavBar from './nav-bar';
import PageContainer from './page-container';
import UserActions from './user-actions';
import MobileNavbar from './mobile-nav-bar';

import EvacuationTable from './evacuation-status-table';
import SiteCreationWizard from './site-creation-wizard';
import SiteWizardDetailsForm from './site-wizard-details-form';

import ExportReport from './export-report-attendance';
import HolderAbsenceReport from './holder-absence-report';

import MfaSettingsForm from './mfa-settings-form';

export {
	LoginForm,
	ChangePasswordForm,
	ClientRegisterForm,
	ForgotPasswordForm,
	HolderForm,
	NotificationForm,
	OperatorForm,
	ResetPasswordForm,
	ImportsForm,
	SiteForm,
	SingleReaderForm,
	AgentForm,
	ZoneForm,
	ReaderForm,
	AntennaForm,
	CameraForm,
	ProfileForm,
	DetectablesForm,
	ClientConfigForm,
	PageContainer,
	LinkedNavigationMenu,
	LinkedSideNavigation,
	NavBar,
	UserActions,
	EvacuationTable,
	MobileNavbar,
	SiteCreationWizard,
	SiteWizardDetailsForm,
	ExportReport,
	HolderAbsenceReport,
	MfaSettingsForm,
};

export default null;



// WEBPACK FOOTER //
// ./src/smart-components/index.js